export default __webpack_public_path__ + "static/media/spring_fest.5805d6c8.PNG";